import { useGetPurchased } from "api/user";

const useIsPurchased = ({ contentType }) => {
  const { data: purchases } = useGetPurchased({ contentType })

  const isPurchased = (uuid) => {
    const content = purchases?.find((cont) => cont.uuid === uuid);
    return !!content
  };

  return { isPurchased, isPurchasesLoaded: !!purchases }
}

export default useIsPurchased;